<template>
  <div class="sc-map">
    <ProductCard>
    </ProductCard>

    <b-row no-gutters>

      <b-col sm="6" md="4" lg="3" >
        <router-link to="infection-feast" >
          <div class="card-container" >
            <div class="card-content" >
              <div class="img-container" >
                <img src="../assets/SC_Map/Infection_Feast.png">
              </div>
              <div class="title">感染盛宴</div>
            </div>
          </div>
        </router-link>
      </b-col>
      <b-col sm="6" md="4" lg="3" >
        <router-link to="infection-outbreak-beta" >
          <div class="card-container" >
            <div class="card-content" >
              <div class="img-container" >
                <img src="../assets/SC_Map/Infection_Outbreak_Beta.jpg">
              </div>
              <div class="title">感染爆发 Beta</div>
            </div>
          </div>
        </router-link>
      </b-col>
      <b-col sm="6" md="4" lg="3" >
        <router-link to="infection-outbreak-alpha" >
          <div class="card-container" >
            <div class="card-content" >
              <div class="img-container" >
                <img src="../assets/SC_Map/Infection_Outbreak_Alpha.jpg">
              </div>
              <div class="title">感染爆发 Alpha</div>
            </div>
          </div>
        </router-link>
      </b-col>
      <b-col sm="6" md="4" lg="3" >
        <router-link to="god-is-dead" >
          <div class="card-container">
            <div class="card-content" >
              <div class="img-container" >
                <img src="../assets/SC_Map/God_is_Dead.jpg">
              </div>
              <div class="title">上帝已死</div>
            </div>
          </div>
        </router-link>
      </b-col>

    </b-row>

  </div>
</template>

<style>
</style>

<script>
  // @ is an alias to /src
  import ProductCard from '@/components/ProductCard.vue'
  export default {
    name: 'sc-map',
    components: {
      ProductCard
    }
  }
</script>
